import React from 'react'

import './PageButton.scss'

export const PageButton = ({
  label,
  disabled,
  onClick = () => {},
}) => {
  return (
    <button
      className="pagination-page-button"
      disabled={ disabled }
      onClick={ onClick }
    >
      <span>
        { label }
      </span>
    </button>
  )
}